module.exports = __webpack_public_path__ + "img/window-restore.0223564c.svg";